import React, { useState, useEffect } from 'react'
import { useTranslate, CreateButton, ExportButton, useStore, useResourceDefinitions } from 'react-admin'
import { Grid, Typography, Button } from '@mui/material'
import { CustomizedBreadcrumbs } from '../../../components/uiElements/styledComponents/BreadCrumbs'
import { Add, ArrowBackIos, Edit, Visibility } from '@mui/icons-material'
import { Link } from 'react-router-dom'
import { CREATE, EDIT, GENERATE, SHOW } from 'src/helper/constants'
import {
  PERMISSION_CREATE,
  PERMISSION_EDIT,
  PERMISSION_SHOW,
  PERMISSION_GENERATE,
} from 'src/helper/Permission'
import { useAppState } from 'src/components/layouts/layoutTopNav'
import { HasPermission } from 'src/helper/HasPermission'

export const ProductNavigationActions = ({ module, entity, id, state, customTitle, ...props }) => {
  const translate = useTranslate()
  const { updateCustomTitle } = useAppState()
  const [_, setPermissionsStore] = useStore('currentResource', '{}')
  const [reservation, setReservation] = useState(
    localStorage.getItem('reservation') !== 'undefined'
      ? JSON.parse(localStorage.getItem('reservation'))
      : '{}'
  )
  const propsResource = useResourceDefinitions()

  useEffect(() => {
    updateCustomTitle('')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entity])

  useEffect(() => {
    setPermissionsStore(JSON.stringify(propsResource[entity]))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propsResource, entity])

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'reservation') {
        setReservation(JSON.parse(e.newValue || '{}'))
      }
    }

    window.addEventListener('storage', handleStorageChange)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
    }
  }, [])

  const getEditButton = () => {
    if (state === SHOW && entity === 'reservation') {
      return (
        <HasPermission resource={entity} permission={PERMISSION_GENERATE}>
          <Button variant='contained' component={Link} to={`/${entity}/${id}`}>
            <Edit sx={{ margin: '0 8px 0 -2px', fontSize: 18 }} />
            {translate('ra.action.edit')}
          </Button>
        </HasPermission>
      )
    }
  }

  const getShowButton = () => {
    if (state === EDIT && entity === 'reservation') {
      return (
        <HasPermission resource={entity} permission={PERMISSION_SHOW}>
          <Button variant='contained' component={Link} to={`/${entity}/${id}/show`}>
            <Visibility sx={{ margin: '0 8px 0 -2px', fontSize: 18 }} />
            {translate('ra.action.show')}
          </Button>
        </HasPermission>
      )
    }
  }

  const getCreateButton = () => {
    let label = 'create'
    let icon = <Add />
    let permission = PERMISSION_CREATE
    if (entity === 'my-devices' || entity === 'bilingform_conciliation'){
      return null
    }
    if (entity === 'payment_entity') {
      label = 'generate_payment'
    } else if (entity === 'reservation') {
      label = 'create_reservation'
      permission = PERMISSION_GENERATE
      icon = null
    } else if (entity === 'billingform'){
      label = 'registerPayment'
    }
    return (
      <HasPermission resource={entity} permission={permission}>
        <CreateButton
          variant='contained'
          resource={entity}
          label={translate(`ra.action.${label}`)}
          icon={icon}
        />
      </HasPermission>
    )
  }

  const getExportButton = () => {
    if (entity === 'payment_entity') {
      return <ExportButton variant='contained' resource={entity} label={translate('ra.action.export')} />
    }
  }

  const getSaveAndListButton = () => {
    if (entity === 'reservation') {
      const isButtonEnabled = reservation
      return (
        <Button variant='contained' component={Link} to={`/${entity}`} disabled={!isButtonEnabled}>
          {translate(`ra.action.save_and_back_to_list`)}
        </Button>
      )
    }
  }

  const getButtons = () => {
    if (entity && state !== CREATE && state !== GENERATE) {
      return (
        <>
          {getEditButton()}
          {getShowButton()}
          {getCreateButton()}
          {getExportButton()}
        </>
      )
    }
  }

  const getButtonsInCreate = () => {
    if (entity && state === CREATE) {
      return <>{getSaveAndListButton()}</>
    }
  }

  const getId = () => {
    if (state && entity === 'reservation') {
      return ` ${customTitle}`
    }

    if (id) {
      return ` #${id}`
    }

    return null
  }

  return (
    <Grid container spacing={3} className='productNavigationActions'>
      <Grid item xs={12} sm={6} className='prodNavLeftBloq'>
        <Button component={Link} to={`/${entity}`} className={` backButton ${id ? '' : 'hiddenElement'}`}>
          <ArrowBackIos className={`backButton`} />
        </Button>

        {!entity && !id && (
          <Typography variant='h3' component='span'>
            {' Dashboard'}
          </Typography>
        )}
        {entity && (
          <Typography variant='h3' component='span'>
            {` ${translate(`ra.entity.${entity}`)}`}
          </Typography>
        )}
        {(customTitle || id) && (
          <Typography variant='h3' component='span'>
            {getId()}
          </Typography>
        )}

        <CustomizedBreadcrumbs module={module} entity={entity} state={state} />
      </Grid>

      <Grid item xs={12} sm={6} className='prodNavRightBloq'>
        {getButtons()}
        {getButtonsInCreate()}
      </Grid>
    </Grid>
  )
}
